import { useEffect, useState } from 'react';

import { WorkOrderStatus } from '@gearbelt/global';
import { Button } from '@gearbelt/ui/components';

import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Select } from '@/components/ui/select';

const WORK_ORDER_STATUS_OPTIONS: Array<{ label: string; value: WorkOrderStatus }> = [
  { label: 'Open', value: WorkOrderStatus.Open },
  { label: 'Closed', value: WorkOrderStatus.Closed },
];

function UpdateWorkOrderStatusDialog({
  open,
  onOpenChange,
  callback,
  loading,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  callback: (value: WorkOrderStatus) => void;
  loading: boolean;
}) {
  const [value, setValue] = useState<{ label: string; value: WorkOrderStatus } | null>(null);

  useEffect(() => {
    if (!open) setValue(null);
  }, [open]);

  function handleSubmit() {
    if (!value) return;
    callback(value.value);
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="w-11/12 rounded-md sm:max-w-lg">
        <DialogHeader>
          <DialogTitle>Edit Work Order Status</DialogTitle>
          <DialogDescription className="text-secondary-text text-left">
            Bulk editing will change the status of all the work orders you selected.
          </DialogDescription>
        </DialogHeader>

        <Select<{ label: string; value: WorkOrderStatus }>
          onChange={setValue}
          name="Work Order Status"
          options={WORK_ORDER_STATUS_OPTIONS}
          className="w-full"
        />

        <DialogFooter>
          <Button type="submit" variant="success" disabled={loading || !value} onClick={handleSubmit}>
            Save
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export { UpdateWorkOrderStatusDialog };
